
<div style="margin-top:30px;">
<div *ngIf="displayQuickSearch === true">

    <ng-container *ngIf="screenWidth > mobileScreenSize" >
        <div class="full-size-layout" >
        <mat-accordion class="example-headers-align" multi>
          
              <mat-expansion-panel 
                [expanded]="displayQuickSearchRegion"
                (opened)="displayQuickSearchRegion = true"
                (closed)="displayQuickSearchRegion = false">
              <mat-expansion-panel-header #matExpansionPanel style="background-color: #003087;color:white;">
                <mat-panel-title>
                  <span style="color:white;font-weight:bold;font-size:21px">Invoice Search</span>
                </mat-panel-title>
                <mat-panel-description>
                  <span style="color:white;font-weight:bold;font-size:21px">{{lotDisplayName}}</span>
                </mat-panel-description>
              </mat-expansion-panel-header>
  
              <form 
              (ngSubmit)="onQuickSearchDoSearch()" 
              novalidate
              [formGroup]="quicksearchForm" 
              style="margin-top:20px;">
              
    
          <div class="row mt-3" style="width: 100%">
            <div class="col-6">
              <mat-form-field appearance="fill" style="width:100%;color:gray">
                <mat-label>Customer Type</mat-label>
                <mat-select style="width:100%" formControlName="customerType">
                    <mat-option value="ALL">All</mat-option>
                    <mat-option value="PARKERPAID">Parker Paid</mat-option>
                    <mat-option value="COMPANYPAID">Company Paid</mat-option>
                  </mat-select>
              </mat-form-field>
            
            </div>
    
            <div class="col-6">
              <mat-form-field appearance="fill" style="width:100%">
                <mat-label>Invoice No:</mat-label>
                <input matInput placeholder="Invoice No" formControlName="invoiceNumber">
              </mat-form-field>
            </div>
    
            <div class="col-6">
              <mat-form-field appearance="fill" style="width:100%">
                <mat-label>Parker Name or Parker Id:</mat-label>
                <input matInput placeholder="Parker Name or Parker Id" formControlName="parkerName">
              </mat-form-field>
            </div>
    
            <div class="col-6">
              <mat-form-field appearance="fill" style="width:100%">
                <mat-label>Revenue Dates:</mat-label>
                <mat-date-range-input [rangePicker]="pickerRevenueDates">
                  <input matStartDate placeholder="Revenue Start date" DateToCurrentYear  formControlName="revenueStartDate">
                  <input matEndDate placeholder="Revenue End date" DateToCurrentYear formControlName="revenueEndDate">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="pickerRevenueDates"></mat-datepicker-toggle>
                <mat-date-range-picker #pickerRevenueDates></mat-date-range-picker>
              </mat-form-field>
            </div>
            
    
            <div class="col-6">
              <mat-form-field appearance="fill" style="width:100%">
                <mat-label>Company Name:</mat-label>
                <input matInput placeholder="Company Name" formControlName="companyName">
              </mat-form-field>
            </div>
    
            <div class="col-6">
              <mat-form-field appearance="fill" style="width:100%">
                <mat-label>Transaction Date From:</mat-label>
                <mat-date-range-input [rangePicker]="pickerTransactionDates">
                  <input matStartDate placeholder="Transaction Start date" DateToCurrentYear formControlName="transactionStartDate" >
                  <input matEndDate placeholder="Transaction End date" DateToCurrentYear formControlName="transactionEndDate">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="pickerTransactionDates"></mat-datepicker-toggle>
                <mat-date-range-picker #pickerTransactionDates></mat-date-range-picker>
              </mat-form-field>
            </div>
    
            <div class="col-6">
              <mat-form-field appearance="fill" style="width:100%">
                <mat-label>Invoice Type</mat-label>
                <mat-select style="width:100%" formControlName="invoiceType">
                    <mat-option value="ALL">All</mat-option>
                    <mat-option value="GB">GB's</mat-option>
                    <mat-option value="MI">MI's</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
  
            <div class="col-6">
              <mat-form-field appearance="fill" style="width:100%">
                <mat-label>Invoice Balances:</mat-label>
                  <mat-select style="width:100%" formControlName="includeZeroBalances">
                    <mat-option value="NO">Open Balance</mat-option>
                    <mat-option value="YES">Include $0 Balances</mat-option>
                    <mat-option value="ONLY ZERO BALANCES">Only $0 Balances</mat-option>
                    <mat-option value="ONLY CREDIT BALANCES">Only Credit Balances</mat-option>
                    <mat-option value="PAST DUE BALANCES">Past Due Balances</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
          </div>
          <!-- End Accordian Expansion Panel -->
              
          <!-- <div *ngIf="LotListByUserName.length > 0"> -->
            <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;" id="btnSearch">Search</button>
            <button type="button" class="btn btn-light mt-3" style="margin-left:5px;" (click)="doSearchCriteriaReset()" >Clear</button>
          <!-- </div> -->
      </form>
          <div class="form-check mt-2" style="margin-left:20px;font-size:12px;">
            <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked" checked  [(ngModel)]="cookieAutoHideSearchCriteria">
            <label class="form-check-label" for="flexCheckChecked">
              Hide Invoice Search Criteria on Search
            </label>
            </div>

          
            </mat-expansion-panel>
         
          </mat-accordion>
        
          <div class="row  mt-3" style="margin-left:0px;margin-right:10px;">
          
          
        </div>
        
    </div>
<!-- </div> -->
    </ng-container>  
    
  </div>
  
  
  </div>
  <app-quick-search-results [quickSearchCriteria]=quickSearchCriteria></app-quick-search-results>
  
  
  
   
  
  


